import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/shared/auth/auth.service';
import { WebsocketService } from '@app/shared/websocket/websocket.service';
import { map, Observable, Subject } from 'rxjs';
import { WebsocketInformationsService } from '@app/shared/websocket/websocket-informations.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: false,
})
export class HomePageComponent implements OnDestroy {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  isMenuOpen: boolean = false;
  isHandset$: Observable<boolean>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private breakpointObserver: BreakpointObserver,
    private authService: AuthService,
    private websocketService: WebsocketService,
    private websocketModalService: WebsocketInformationsService,
  ) {
    this.websocketService.connect();
    this.isHandset$ = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map((result) => result.matches));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }
}
